export function parseTemplateNames(html: string): string[] {
  const pattern = /<a\s+[^>]*href="\/templates\/emails\/([^"]+)"[^>]*>/gi;
  const names: string[] = [];
  let match: RegExpExecArray | null;

  while ((match = pattern.exec(html)) !== null) {
    names.push(match[1]);
  }

  return names;
}
